module.exports = __webpack_public_path__ + "static/media/Number1.79667c31.svg";